import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useOrgSlug } from "@/common/artemis-operations/organization";
import { FullSpin } from "@/components/base";

export const Route = createFileRoute("/_authenticated/home")({
	component: Home,
});

/**
 * Slug-less post-login landing. Resolves the user's org slug and forwards to the org-scoped app.
 * (Onboarding for a user with no org yet is handled upstream in the `_authenticated` layout.)
 */
function Home() {
	const slug = useOrgSlug();
	if (!slug) {
		return (
			<div style={{ height: "100vh" }}>
				<FullSpin />
			</div>
		);
	}
	return (
		<Navigate to="/$orgSlug/workspaces" params={{ orgSlug: slug }} replace />
	);
}
